<template>
    <div ref="modal" class="modal fade" :class="{'show': is_loaded}" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-xl">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">Game Information</h4>
                    <a class="close" data-dismiss="modal" aria-hidden="true" @click="close()">×</a>
                </div>
                <div class="modal-body p-b-0">
                    <header>
                        <div class="game-info">
                            <h3><span>Game </span><span class="text-warning">#{{info.game_id}}</span></h3>
                            <p><span>{{$trans('label.Busted At')}}: </span><span class="busted-at">{{info.busted_at}}x</span></p>
                        </div>
                        <div class="game-date">
                            <span class="">{{$trans('label.Date')}}: </span> {{info.date}} <small>{{info.date_ago}}</small>
                        </div>
                        <hr/>
                    </header>
                    <div class="players">
                        <h5>{{$trans('label.Players')}} ({{info.players.length}})</h5>
                        <div>
                            <div class="text-center" v-if="info.players.length == 0" style="padding: 20px 0;">
                                No Players
                            </div>
                            <table class="table table-light table-sm table-striped table-bordered table-hover" v-if="info.players.length > 0">
                                <thead>
                                <tr>
                                    <th>{{$trans('th.Player')}}</th>
                                    <th>{{$trans('th.Bet')}}</th>
                                    <th>{{$trans('th.Cashed Out')}}</th>
                                    <th>{{$trans('th.Profit')}}</th>
<!--                                    <th></th>-->
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="player in info.players">
                                    <td><a href="javascript:void(0)" style="color: #ff5a5f;" :style="{color: player.cashed_out ? '#2ecc71' : '#ff5a5f'}">{{utils.maskedUsername(player.username, state.user_id == player.user_id ? false : state.display_masked_username)}}</a></td>
                                    <td>{{utils.comma(player.bet)}}</td>
                                    <td>{{player.cashed_out ? player.cashed_out + 'x' : '-'}}</td>
                                    <td>{{utils.comma(Clib.formatDecimals(player.profit))}}</td>
<!--                                    <td></td>-->
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <pre>{{info.hash}}</pre>
                    </div>
                </div>
                <div class="modal-footer">

                </div>
            </div><!-- /.modal-content -->
        </div><!-- /.modal-dialog -->
    </div>
</template>

<script>

    import modal from '../libraries/modal';

    export default {
        name: "modal-game-information",
        props: ['state'],
        data: function()
        {
            let self = this;

            return {
                utils: utils,
                Clib: Clib,
                is_loaded: false,
                info: {
                    channel: null,
                    game_id: null,
                    user_id: null,
                    hash: null,
                    date: null,
                    date_ago: null,
                    busted_at: null,
                    players: [],
                }
            };
        },
        created()
        {
            this.info.channel = this.state.modals.game_information.data.channel;
            this.info.game_id = this.state.modals.game_information.data.game_id;
            this.info.user_id = this.state.user_id;
            // this.info.channel = 'GS01KRW';
            // this.info.game_id = 1000032;
            // this.info.user_id = 1000532;
        },
        mounted()
        {
            this.state.modals.game_information.template = this.$refs['modal'];
            modal.set(this.state.modals.game_information);
            modal.show();

            this.init();
        },
        methods: {
            init()
            {
                this.search(1);
            },
            close()
            {
                modal.close();
            },
            search()
            {
                let self = this;

                let params = {params: {channel: this.info.channel, game_id: this.info.game_id, user_id: this.info.user_id}};

                axios(`/ajax/player/game`, params).then(function(response) {

                    modal.loaded();

                    let data = response.data.data;

                    self.is_loaded = true;
                    // self.point_start                = data.point_start;
                    // self.pagination.total_page      = data.total_page;

                    // self.info.username              = data.username;
                    // self.info.joined                = self.$moment(data.joined).format('YYYY.MM.DD');
                    // self.info.joined_ago            = data.joined_ago;
                    // self.info.currency              = self.state.currency.toLowerCase();
                    // self.info.games_played          = utils.comma(data.games_played);
                    // self.info.balance               = utils.comma(data.balance);
                    // self.info.net_profit            = utils.comma(data.net_profit);
                    // self.info.all_time_high         = utils.comma(data.all_time_high);
                    // self.info.all_time_low          = utils.comma(data.all_time_low);

                    self.info.hash                  = data.game.hash;
                    self.info.busted_at             = data.game.busted_at;
                    self.info.date                  = data.game.date;
                    self.info.date_ago              = data.game.date_ago;
                    self.info.players               = data.players;

                    self.info.players.sort(function(a, b) {
                        let r = b.cashed_out - a.cashed_out;
                        if (r !== 0) return r;
                        return a.profit > b.profit ? 1 : -1;
                    });

                });

            },
        }
    }
</script>

<style scoped>

</style>
